import axios from "axios";
import { API_ENDPOINTS } from "@config/api";
import { attachAuthInterceptor } from "@shared/utils/authInterceptor";

/**
 * Axios instance for the YTG API, preconfigured with the YTG base URL, cookie
 * credentials, and a shared auth interceptor (401 refresh handling).
 */
export const ytgApi = axios.create({
    baseURL: API_ENDPOINTS.YTG,
    timeout: 30000,
    withCredentials: true,
    headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest",
    },
});

attachAuthInterceptor(ytgApi, { name: "YTG API" });
